<template>
    <div>
        <view-item v-if="!!item" :item="item" @delete-item="deleteType" @success="alertSuccess" @error="showError"
            @cancel="item = false"></view-item>

        <list-items v-else title="ItemVendors" :items="assetVendors" @show-item="showItem" ref="table">
            <b-row>
                <b-col class="text-right-md offset-xl-8">
                    <button block class="btn btn-primary btn-block" variant="primary" @click="item = {}"
                        v-if="hasPermissionCreate"><img v-b-tooltip.hover :title="$addLabel()"
                            src="@/assets/images/icon/blue-add.svg" /></button>
                </b-col>
            </b-row>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'assetVendors',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('asset_vendor') },
        assetVendors() {
            const vendors = this.$store.state.assets.vendors
            console.log('vendors', vendors)
            return vendors
        },
    },

    methods: {
        cancelItem() {
            this.item = null
        },

        doSearch() {
            this.$store.dispatch('assets/listVendors')
        },

        showItem(id) {
            const item = this.assetVendors.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, name, message) {
            this.genericToast(
                this.componentName,
                action,
                'success',
                `"${name}" ${message}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error}`
            )
        },
    },
}
</script>
<style></style>
